export default __webpack_public_path__ + "static/media/benefit.580267c1.png";